import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function CalculadoraPage() {
  const [contacts, setContacts] = useState(10);
  const [closeRate, setCloseRate] = useState(30);
  const [price, setPrice] = useState(350);
  const [recurring, setRecurring] = useState(false);
  const [bump, setBump] = useState(false);
  const closed = Math.round(contacts * (closeRate / 100));
  const sitesIncome = closed * price;
  const bumpIncome = bump ? closed * 17 : 0;
  const weeklyIncome = sitesIncome + bumpIncome;
  const monthlyIncome = weeklyIncome * 4;
  const recurringMonth = recurring ? closed * 4 * 99 : 0;
  const yearlyIncome = monthlyIncome * 12 + recurringMonth * 12;
  const fmt = (n: number) => {
    return '$' + Math.round(n).toLocaleString('en-US');
  };
  return <div className="min-h-screen bg-navy font-body text-white" data-id="element-531">
      {/* Header */}
      <header className="border-b border-gold/20 bg-navy-dark" data-id="element-532">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-533">
          <a href="/" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-534">
            <ArrowLeftIcon className="h-5 w-5" data-id="element-535" />
            <span className="font-body text-sm" data-id="element-536">Volver</span>
          </a>
          <h1 className="font-heading font-black text-xl md:text-2xl" data-id="element-537">
            <span className="text-gold" data-id="element-538">AI</span> Web Closer
          </h1>
          <div className="w-20" data-id="element-539" />
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-540">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-541">
          <h2 className="font-heading font-black text-3xl md:text-4xl mb-2" data-id="element-542">
            ¿Cuánto Puedes Ganar <span className="text-gold" data-id="element-543">Esta Semana?</span>
          </h2>
          <p className="font-body text-sm text-gray-400" data-id="element-544">
            Mueve los controles y calcula tu ingreso real con el sistema AI Web
            Closer
          </p>
        </motion.div>

        {/* Calculator Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 md:p-8 mb-6" data-id="element-545">
          <div className="font-heading font-bold text-xs tracking-widest text-gold uppercase mb-6" data-id="element-546">
            Calculadora de Ingresos
          </div>

          {/* Slider 1: Contacts */}
          <div className="mb-6" data-id="element-547">
            <div className="flex justify-between items-center mb-2" data-id="element-548">
              <span className="font-body text-sm text-gray-300" data-id="element-549">
                Negocios que contactas por semana
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[60px] text-center" data-id="element-550">
                {contacts}
              </div>
            </div>
            <input type="range" min="1" max="50" value={contacts} onChange={e => setContacts(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-551" />
          </div>

          {/* Slider 2: Close Rate */}
          <div className="mb-6" data-id="element-552">
            <div className="flex justify-between items-center mb-2" data-id="element-553">
              <span className="font-body text-sm text-gray-300" data-id="element-554">
                Tasa de cierre (% que dice SÍ)
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[60px] text-center" data-id="element-555">
                {closeRate}
                <span className="text-xs" data-id="element-556">%</span>
              </div>
            </div>
            <input type="range" min="5" max="60" value={closeRate} onChange={e => setCloseRate(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-557" />
          </div>

          {/* Slider 3: Price */}
          <div className="mb-8" data-id="element-558">
            <div className="flex justify-between items-center mb-2" data-id="element-559">
              <span className="font-body text-sm text-gray-300" data-id="element-560">
                Precio por sitio web
              </span>
              <div className="font-heading font-bold text-lg text-gold bg-gold/10 border border-gold/30 rounded-lg px-3 py-1 min-w-[70px] text-center" data-id="element-561">
                ${price}
              </div>
            </div>
            <input type="range" min="150" max="1500" step="50" value={price} onChange={e => setPrice(Number(e.target.value))} className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer accent-gold" data-id="element-562" />
          </div>

          {/* Divider */}
          <div className="relative mb-6" data-id="element-563">
            <div className="absolute inset-0 flex items-center" data-id="element-564">
              <div className="w-full border-t border-gold/20" data-id="element-565"></div>
            </div>
          </div>

          {/* Toggle: Recurring */}
          <div className="flex items-center gap-3 mb-4 p-3 bg-navy-light/50 rounded-lg border border-gold/10" data-id="element-566">
            <span className="font-body text-sm text-gray-300 flex-1" data-id="element-567">
              Añadir paquete de mantenimiento mensual ($99/cliente)
            </span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-568">
              <input type="checkbox" checked={recurring} onChange={e => setRecurring(e.target.checked)} className="sr-only peer" data-id="element-569" />
              <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gold" data-id="element-570"></div>
            </label>
            <div className="font-heading font-bold text-xs text-navy bg-gold rounded px-2 py-1" data-id="element-571">
              +$99/mes
            </div>
          </div>

          {/* Toggle: Bump */}
          <div className="flex items-center gap-3 mb-8 p-3 bg-navy-light/50 rounded-lg border border-gold/10" data-id="element-572">
            <span className="font-body text-sm text-gray-300 flex-1" data-id="element-573">
              Incluir upsell Kit del Primer Cliente ($17)
            </span>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-574">
              <input type="checkbox" checked={bump} onChange={e => setBump(e.target.checked)} className="sr-only peer" data-id="element-575" />
              <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gold" data-id="element-576"></div>
            </label>
            <div className="font-heading font-bold text-xs text-navy bg-gold rounded px-2 py-1" data-id="element-577">
              +$17
            </div>
          </div>

          {/* Breakdown */}
          <div className="pt-2" data-id="element-578">
            <div className="font-heading text-xs font-bold tracking-widest text-gray-400 uppercase mb-4" data-id="element-579">
              Desglose Semanal
            </div>
            <div className="space-y-2" data-id="element-580">
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-581">
                <span className="font-body text-sm text-gray-400" data-id="element-582">
                  Negocios contactados
                </span>
                <span className="font-heading font-bold text-white" data-id="element-583">
                  {contacts}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-584">
                <span className="font-body text-sm text-gray-400" data-id="element-585">
                  Clientes cerrados
                </span>
                <span className="font-heading font-bold text-white" data-id="element-586">
                  {closed}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-587">
                <span className="font-body text-sm text-gray-400" data-id="element-588">
                  Ingreso por sitios web
                </span>
                <span className="font-heading font-bold text-gold" data-id="element-589">
                  {fmt(sitesIncome)}
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-700/50" data-id="element-590">
                <span className="font-body text-sm text-gray-400" data-id="element-591">
                  Ingreso recurrente (mes 1)
                </span>
                <span className="font-heading font-bold text-gold" data-id="element-592">
                  {recurring ? `${fmt(closed * 99)}/sem` : '$0'}
                </span>
              </div>
              <div className="flex justify-between items-center py-3 border-t border-gold/20 mt-2" data-id="element-593">
                <span className="font-heading font-bold text-white" data-id="element-594">
                  Total semana 1
                </span>
                <span className="font-heading font-black text-xl text-gold" data-id="element-595">
                  {fmt(weeklyIncome)}
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Pricing Reference */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy-dark border border-gold/20 rounded-xl p-6 md:p-8 mb-6" data-id="element-596">
          <div className="font-heading font-bold text-xs tracking-widest text-gold uppercase mb-6" data-id="element-597">
            💰 Precios de Referencia por Nicho
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-598">
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-599">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-600">
                🍕 Restaurantes
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-601">
                $300–$500
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-602">
                Alta urgencia
              </div>
            </div>
            <div className="bg-gold/10 border-2 border-gold rounded-lg p-4 text-center relative" data-id="element-603">
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold text-navy text-[10px] font-black px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-604">
                ⭐ RECOMENDADO
              </div>
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-605">
                🦷 Dentistas
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-606">
                $500–$900
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-607">
                Mayor ticket
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-608">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-609">
                🔧 Talleres
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-610">
                $250–$450
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-611">
                Fácil de cerrar
              </div>
            </div>
            <div className="bg-gold/10 border-2 border-gold rounded-lg p-4 text-center relative" data-id="element-612">
              <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-gold text-navy text-[10px] font-black px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-613">
                ⭐ RECOMENDADO
              </div>
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-614">
                ⚖️ Abogados
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-615">
                $700–$1,500
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-616">
                Máximo ticket
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-617">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-618">
                ✂️ Peluquerías
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-619">
                $200–$350
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-620">
                Volumen alto
              </div>
            </div>
            <div className="bg-navy-light/50 border border-gray-700 rounded-lg p-4 text-center" data-id="element-621">
              <div className="font-body text-sm font-semibold text-gray-300 mb-2" data-id="element-622">
                🏋️ Gimnasios
              </div>
              <div className="font-heading font-black text-lg text-gold" data-id="element-623">
                $350–$600
              </div>
              <div className="font-body text-xs text-gray-500 mt-1" data-id="element-624">
                Buen margen
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}